import { Mic, MicOff, Video, VideoOff, Loader2 } from 'lucide-react';

interface CallControlsProps {
  micEnabled: boolean;
  camEnabled: boolean;
  isLoading: boolean;
  onToggleMic: () => void;
  onToggleCam: () => void;
}

export function CallControls({
  micEnabled,
  camEnabled,
  isLoading,
  onToggleMic,
  onToggleCam,
}: CallControlsProps) {
  return (
    <div className="flex items-center gap-1.5 bg-cinema-900/80 p-1 rounded-lg border border-cinema-700/60">
      {/* Microphone Toggle Button */}
      <button
        onClick={onToggleMic}
        disabled={isLoading}
        className={`flex items-center gap-1.5 px-2.5 py-1 rounded text-xs font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lamp disabled:opacity-50 ${
          micEnabled
            ? 'bg-lamp/20 text-lamp border border-lamp/40 shadow-sm'
            : 'bg-cinema-850 hover:bg-cinema-800 text-cinema-400 hover:text-cinema-200 border border-cinema-700/60'
        }`}
        title={micEnabled ? 'Mute Microphone' : 'Turn on Microphone'}
        aria-label={micEnabled ? 'Mute Microphone' : 'Turn on Microphone'}
        aria-pressed={micEnabled}
      >
        {isLoading && !camEnabled ? (
          <Loader2 className="w-3.5 h-3.5 animate-spin text-lamp" />
        ) : micEnabled ? (
          <Mic className="w-3.5 h-3.5 text-lamp" />
        ) : (
          <MicOff className="w-3.5 h-3.5 text-cinema-400" />
        )}
        <span className="hidden md:inline">{micEnabled ? 'Mic On' : 'Mic Off'}</span>
      </button>

      {/* Camera Toggle Button */}
      <button
        onClick={onToggleCam}
        disabled={isLoading}
        className={`flex items-center gap-1.5 px-2.5 py-1 rounded text-xs font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lamp disabled:opacity-50 ${
          camEnabled
            ? 'bg-lamp/20 text-lamp border border-lamp/40 shadow-sm'
            : 'bg-cinema-850 hover:bg-cinema-800 text-cinema-400 hover:text-cinema-200 border border-cinema-700/60'
        }`}
        title={camEnabled ? 'Turn off Camera' : 'Turn on Camera'}
        aria-label={camEnabled ? 'Turn off Camera' : 'Turn on Camera'}
        aria-pressed={camEnabled}
      >
        {isLoading && camEnabled ? (
          <Loader2 className="w-3.5 h-3.5 animate-spin text-lamp" />
        ) : camEnabled ? (
          <Video className="w-3.5 h-3.5 text-lamp" />
        ) : (
          <VideoOff className="w-3.5 h-3.5 text-cinema-400" />
        )}
        <span className="hidden md:inline">{camEnabled ? 'Cam On' : 'Cam Off'}</span>
      </button>
    </div>
  );
}

